import type MailTriageAction from "owa-service/lib/contract/MailTriageAction";
import type SurfaceActionsOptionState from "../store/schema/SurfaceActionsOptionState";
import type { HoverActionKey } from "owa-outlook-service-option-store";
import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
export interface SelectSurfaceActionsOptionState {
    optionState: SurfaceActionsOptionState;
}

export function getMailTriageActionsFromHoverActionKeys(hoverActionKeys: HoverActionKey[]): MailTriageAction[] {
    const actionKeys: MailTriageAction[] = [];
    hoverActionKeys.forEach(action => {
        switch (action) {
            case "None":
                actionKeys.push(0);
                break;
            case "Delete":
                actionKeys.push(1);
                break;
            case "Archive":
                actionKeys.push(2);
                break;
            case "PinUnpin":
                actionKeys.push(3);
                break;
            case "ReadUnread":
                actionKeys.push(4);
                break;
            case "FlagUnflag":
                actionKeys.push(5);
                break;
            case "Move":
                actionKeys.push(6);
                break;
        }
    });
    return actionKeys;
}

export function getHoverActionKeysFromMailTriageActions(mailTriageActions: MailTriageAction[]): HoverActionKey[] {
    const hoverKeys: HoverActionKey[] = [];
    // Create a set for fast lookup and count None occurrences simultaneously
    const actionSet = new Set<MailTriageAction>();
    let noneCount = 0;
    for (const action of mailTriageActions) {
        if (action === 0) {
            noneCount++;
        }
        actionSet.add(action);
    }
    
    // Define the desired order and build result accordingly
    const orderedHoverActionKeys: HoverActionKey[] = [
        "None",
        "Move",
        "ReadUnread",
        "FlagUnflag",
        "PinUnpin",
        "Archive",
        "Delete",
    ];
    const orderedMailTriageActions: MailTriageAction[] = getMailTriageActionsFromHoverActionKeys(orderedHoverActionKeys);
    
    for (let i = 0; i < orderedMailTriageActions.length; i++) {
        const actionKey = orderedHoverActionKeys[i];
        const mailTriageAction = orderedMailTriageActions[i];
        
        if (actionSet.has(mailTriageAction)) {
            if (actionKey === "None") {
                // Add 'None' multiple times based on count
                for (let j = 0; j < noneCount; j++) {
                    hoverKeys.push(actionKey);
                }
            }
            else {
                // Add other actions once
                hoverKeys.push(actionKey);
            }
        }
    }
    return hoverKeys;
}

export default function getHoverSurfaceAction(): HoverActionKey[] {
    const mailTriageActions = getUserConfiguration()?.ViewStateConfiguration?.MailTriageOnHoverActions;
    
    if (mailTriageActions) {
        return getHoverActionKeysFromMailTriageActions([...mailTriageActions]);
    }
    
    return ["FlagUnflag", "Delete", "PinUnpin"];
}
